import React from "react";
import LogoAnimation from "./LogoAnimation";

type Props = {
  fullHeight?: boolean;
  color?: string;
};

const Loader: React.FC<Props> = ({ fullHeight, color }) => {
  return (
    <div
      className={`flex justify-center items-center ${
        fullHeight ? "min-h-screen" : "h-[300px]"
      }`}
    >
      <LogoAnimation />
    </div>
  );
};

export default Loader;
